import * as React from "react";
import PropTypes from "prop-types";

function CircleCheckIcon(props) {
  const { className, height, width, color = "currentColor" } = props;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 30 30"
    >
      <g id="Checklist_Icon" data-name="Checklist Icon">
        <path
          id="check"
          d="M14.5,27A12.5,12.5,0,1,0,2,14.5,12.5,12.5,0,0,0,14.5,27Zm5.792-14.52a1.563,1.563,0,0,0-2.21-2.21l-5.145,5.145-2.02-2.02a1.563,1.563,0,1,0-2.21,2.21l3.125,3.125a1.563,1.563,0,0,0,2.21,0Z"
          fill={color}
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
}

CircleCheckIcon.propTypes = {
  className: PropTypes.string,
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
};

export default CircleCheckIcon;
